var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.22v9.011a2.01 2.01 0 0 0 2.003 1.998h9.778a2.007 2.007 0 0 0 1.998-1.997V8.22a2.01 2.01 0 0 0-1.998-2.002H2.003A2.015 2.015 0 0 0 0 8.22ZM8.444.77a2.23 2.23 0 0 0-2.219 2.224v1.889h5.556c1.832 0 3.331 1.51 3.331 3.337v5.561h2.668c1.22 0 2.22-1.004 2.22-2.224V2.994C20 1.774 19 .77 17.78.77H8.444Z",
    fill: "#979BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDupe);
export default __webpack_public_path__ + "static/media/dupe.c428ac446a76e44f6ffcdc6406751dbf.svg";
export { ForwardRef as ReactComponent };